/**
 * Get the full URL for R2 assets (logos, etc.)
 * @param path - The asset path stored in the database (e.g., "logos/kadmon.png")
 * @returns Full URL to the asset
 */
export function getAssetUrl(path: string | null | undefined): string | null {
  if (!path) return null;

  // If path is already a full URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const baseUrl = import.meta.env.VITE_R2_PUBLIC_URL;

  if (!baseUrl) {
    console.warn('[assetUrl] VITE_R2_PUBLIC_URL not configured, returning path as-is:', path);
    return path;
  }

  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // Remove trailing slash from baseUrl if present
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  return `${cleanBaseUrl}/${cleanPath}`;
}
